var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/*
* Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
*/
/*******************************************************************
 * @author Soongjin Park
 * @contact sjpark@detech.co.kr
 * @date 2022-09-01
 * @brief EHP 사업장 관리 개발
 *
 ********************************************************************/
import React, { useEffect, useRef, useState } from "react";
import { useAsync } from "react-async";
import { useNavigate } from 'react-router-dom';
// recoil
import { useRecoilValue, useRecoilState, } from "recoil";
import { userInfoLoginState } from "../../../recoil/userState";
import { loadingBoxState } from "../../../recoil/menuState";
// utils
import clog from "../../../utils/logUtils";
import * as CONST from "../../../utils/Const";
import * as HTTPUTIL from "../../../utils/api/HttpUtil";
import * as CUTIL from "../../../utils/commUtils";
/**
 * @brief EHP 사업장 관리 컴포넌트, 반응형 동작
 * @param -
 * @returns react components
 */
//component
import ZoneList from "./zone/ZoneList";
function CompanyView(props) {
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [isLoadingBox, setRecoilIsLoadingBox] = useRecoilState(loadingBoxState);
    //props
    const isMobile = props.isMobile;
    const setParentIsMobile = props.setIsMobile;
    const selTree = props.selTree;
    const setParentSelTree = props.setSelTree;
    const workMode = props.workMode;
    const setParentWorkMode = props.setWorkMode;
    const setParentAdminType = props.setAdminType;
    const setParentPopWin = props.setPopWin;
    //
    //화면 이동
    const navigate = useNavigate();
    //mobile check
    const mobileRef = useRef(null); // Mobile Check용
    useEffect(() => {
        function handleResize() {
            if (CUTIL.isnull(mobileRef))
                return;
            const mobileTag = mobileRef.current;
            if ((mobileTag.clientHeight <= 0) && (mobileTag.clientWidth <= 0)) {
                setParentIsMobile(true);
            }
            else {
                setParentIsMobile(false);
            }
        }
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    useEffect(() => {
        if (CUTIL.isnull(mobileRef))
            return;
        const mobileTag = mobileRef.current;
        if (!CUTIL.isnull(mobileTag)) {
            if ((mobileTag.clientHeight <= 0) && (mobileTag.clientWidth <= 0)) {
                setParentIsMobile(true);
            }
            else {
                setParentIsMobile(false);
            }
        }
    }, []);
    ////////////////////////////////////////////////////////////////////////////
    const [companyInfo, setCompanyInfo] = useState(null);
    const { data: retData, error, isLoading, reload, run, } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/api/v2/product/company/admindetail?companyId=${selTree.company.companyId}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: selTree
        //watch: selTree.company.companyId+selTree.reload
    });
    useEffect(() => {
        setRecoilIsLoadingBox(true);
        const ERR_URL = HTTPUTIL.resultCheck(isLoading, retData);
        if (ERR_URL.length > 0)
            navigate(ERR_URL);
        if (retData) {
            setRecoilIsLoadingBox(false);
            //clog("IN COMPANY VIEW : RES : " + JSON.stringify(retData));
            if (retData.codeNum == CONST.API_200) {
                setCompanyInfo(retData.body);
            }
        }
    }, [selTree, retData]);
    // 상세사업장 추가
    function onClickUpdateCompany(e) {
        e.stopPropagation();
        //setParentAdminType("COMPANY")
        setParentSelTree("COMPANY", Object.assign(Object.assign({}, selTree), { company: { "companyId": selTree.company.companyId, "companyName": selTree.company.companyName } }));
        setParentWorkMode("UPDATE");
    }
    //clog("IN ZONEVIEW : ZONEINFO : " + JSON.stringify(companyInfo));
    function onClickDoDeleteCompany(e, company) {
        return __awaiter(this, void 0, void 0, function* () {
            var isOk = confirm(`${company.companyName}을(를) 삭제하시겠습니까?`);
            clog("onClickZoneDoDelete : " + isOk);
            if (!isOk)
                return;
            let data = null;
            setRecoilIsLoadingBox(true);
            data = yield HTTPUTIL.PromiseHttp({
                "httpMethod": "DELETE",
                "appPath": `/api/v2/product/company/${company.companyId}`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                /*
                const ERR_URL = HTTPUTIL.resultCheck(false, data);
                if (ERR_URL.length > 0) {
                  setRecoilIsLoadingBox(false);
                  CUTIL.sleep(500);
                  navigate(ERR_URL);
                }
                */
                setRecoilIsLoadingBox(false);
                if (data.codeNum == CONST.API_200) {
                    clog("IN ZONE UPDATE : onClickDoDeleteCompany : " + JSON.stringify(data.body));
                    alert("회사가 삭제되었습니다.");
                    setParentSelTree("COMPANY", Object.assign(Object.assign({}, selTree), { company: { "companyId": "", "companyName": "" }, reload: true }));
                    setParentWorkMode("READ");
                }
                else { // api if
                    // need error handle -> goto system error page?
                    alert(data.body.errorList[0].msg);
                    //setErrorList(data.body.errorList);
                }
                CUTIL.jsclose_Popup("pop-listbox-detail");
            }
        });
    }
    const [companyFold, setCompanyFold] = useState(false);
    return (React.createElement(React.Fragment, null, (companyInfo) &&
        React.createElement("div", { className: "area__right_content workplace__info workplace__main info__input newtype", ref: mobileRef },
            React.createElement("div", { className: "page-top" },
                React.createElement("h2", null,
                    companyInfo.companyName,
                    React.createElement("button", { type: "button", className: `btn-more ${(companyFold) ? "on" : ""}`, onClick: (e) => setCompanyFold(!companyFold) },
                        React.createElement("span", { className: "hide" }, "\uD654\uBA74\uC811\uAE30\uD3BC\uCE58\uAE30"))),
                React.createElement("div", { className: "top-button" },
                    React.createElement("button", { type: "button", className: "btn-edit", onClick: (e) => onClickUpdateCompany(e) },
                        React.createElement("span", { className: "hide" }, "\uC218\uC815")),
                    React.createElement("button", { type: "button", className: "btn-delete", onClick: (e) => onClickDoDeleteCompany(e, companyInfo) },
                        React.createElement("span", { className: "hide" }, "\uC0AD\uC81C")))),
            React.createElement("div", { className: `content__info ${(companyFold) ? "hidden" : ""}` },
                React.createElement("h3", { className: "hide" }, "\uD68C\uC0AC\uBCC4 \uC815\uBCF4"),
                React.createElement("ul", { className: "form__info" },
                    React.createElement("li", null,
                        React.createElement("p", { className: "tit" }, "\uD68C\uC0AC \uBA85"),
                        React.createElement("p", { className: "txt" }, companyInfo.companyName)),
                    React.createElement("li", null,
                        React.createElement("p", { className: "tit" }, "\uD68C\uC0AC URL"),
                        React.createElement("p", { className: "txt" },
                            React.createElement("a", null, companyInfo.url))),
                    React.createElement("li", null,
                        React.createElement("p", { className: "tit" }, "\uC0AC\uC5C5\uC790\uB4F1\uB85D\uBC88\uD638"),
                        React.createElement("p", { className: "txt" }, companyInfo.businessNo)),
                    React.createElement("li", null,
                        React.createElement("p", { className: "tit" }, "\uB300\uD45C \uAD00\uB9AC\uC790"),
                        React.createElement("p", { className: "txt" }, companyInfo.administrator)),
                    React.createElement("li", null,
                        React.createElement("p", { className: "tit" }, "\uCCAD\uAD6C/\uC815\uC0B0 \uB2F4\uB2F9"),
                        React.createElement("p", { className: "txt" }, companyInfo.accountManager)),
                    React.createElement("li", null,
                        React.createElement("p", { className: "tit" }, "\uCCAD\uAD6C/\uC815\uC0B0 \uB2F4\uB2F9 Tel"),
                        React.createElement("p", { className: "txt" }, companyInfo.accMngrTelephone)),
                    React.createElement("li", null,
                        React.createElement("p", { className: "tit" }, "I/F Info"),
                        React.createElement("p", { className: "txt" }, companyInfo.interfaceInfo)),
                    React.createElement("li", null,
                        React.createElement("p", { className: "tit" }, "\uBA54\uBAA8"),
                        React.createElement("p", { className: "txt" }, companyInfo.memo)))),
            React.createElement(ZoneList, { companyInfo: companyInfo, setSelTree: props.setSelTree, setWorkMode: props.setWorkMode, setPopWin: props.setPopWin }))));
}
;
export default CompanyView;
